// class declaration
export class BapiReturnCode {
    // composition of the model
    public return_code;
}



// WEBPACK FOOTER //
// ./src/app/model/common/bapi_return_code.model.ts